/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.4.23",
    versionName: "0.2.0-nightly.2026.4.23",
    versionChannel: "nightly",
    buildDate: "2026-04-23T00:22:40.061Z",
    commitHash: "b02ac5bc91ef45325d0e71ee6b8a88e94a440973",
};
